"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSeriesProperty = exports.seriesPropertyDefinition = void 0;
exports.seriesPropertyDefinition = {
    name: 'series',
    type: 'asset',
    constraints: [
        {
            name: 'stencils',
            argument: ['event-series'],
        },
    ],
    multiple: false,
    view: { label: 'Series' },
};
const isSeriesProperty = (prop) => {
    return prop.name === exports.seriesPropertyDefinition.name;
};
exports.isSeriesProperty = isSeriesProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VyaWVzLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc2VyaWVzLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsSUFBSSxFQUFFLFFBQVE7SUFDZCxJQUFJLEVBQUUsT0FBTztJQUNiLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsY0FBYyxDQUFDO1NBQzNCO0tBQ0Y7SUFDRCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxRQUFRLEVBQUU7Q0FDTSxDQUFBO0FBSTFCLE1BQU0sZ0JBQWdCLEdBQUcsQ0FBQyxJQUFrQixFQUEwQixFQUFFO0lBQzdFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxnQ0FBd0IsQ0FBQyxJQUFJLENBQUE7QUFDcEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxnQkFBZ0Isb0JBRTVCIn0=